import moment from "moment";
import PLANE from "../../assets/images/plane.png";
import BRIEFCASE from "../../assets/images/briefcase.png";
import BACKPACK from "../../assets/images/backpack.png";
import { useMemo, useState } from "react";
import { API_URL } from "../../app/config";
import { axiosApiInstance } from "../../app/axios";
import { useAppSelector } from "../../app/hooks";
import Loading from "../../components/spinner/Loading";
import { useLocation } from "react-router";
import { getRequestId } from "../../_helpers/miscUtils";
import {
  formatMinToHRAndMin,
  getTotalTravelDuration,
} from "../../_helpers/dateUtils";
import { getFlightImage } from "../../_helpers/flightUtils";
import { FlightImage } from "../../components/flightimage/FlightImage";

const ReviewFlightRouteCard = ({
  route,
  index,
}: // fareRule,
{
  route: any;
  index: number;
  // fareRule: any;
}) => {
  const location = useLocation();
  const [fareRulesLoading, setFareRulesLoading] = useState(false);
  const [fareRule, setFareRule] = useState<any>();

  // const params = new URLSearchParams(location.search);
  // const Search_Key = params.get("Search_Key");
  const Search_Key = location.state?.Search_Key;

  const getFareRules = async (Fare_Id: any, Flight_Key: string) => {
    try {
      setFareRulesLoading(true);
      const Request_Id = getRequestId();
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineFareRule/Air_FareRule`,
        {
          Fare_Id: Fare_Id,
          Search_Key: Search_Key || "",
          Flight_Key: Flight_Key,
          Request_Id,
        }
      );
      setFareRule(response.data?.FareRules);
    } catch (error) {
      console.error("Error fetching fare rules results:", error);
    } finally {
      setFareRulesLoading(false);
    }
  };
  const startTime = useMemo(
    () => moment(route?.Flight?.Segments[0]?.Departure_DateTime),
    [route]
  );
  const endTime = useMemo(
    () =>
      moment(
        route?.Flight?.Segments[route?.Flight?.Segments?.length - 1]
          ?.Arrival_DateTime
      ),
    [route]
  );
  const priceDetails = route?.Flight?.Fares && route?.Flight?.Fares[0];

  const cancellationCharges =
    (priceDetails?.FareDetails[0] &&
      priceDetails?.FareDetails[0]?.CancellationCharges) ||
    [];
  const rescheduleCharges =
    (priceDetails?.FareDetails[0] &&
      priceDetails?.FareDetails[0]?.RescheduleCharges) ||
    [];
  // const cabinClass = priceDetails?.fd?.ADULT?.cc;

  const adultCheckingBaggage =
    priceDetails?.FareDetails[0]?.Free_Baggage?.Check_In_Baggage;
  const adultCabbinBaggage =
    priceDetails?.FareDetails[0]?.Free_Baggage?.Hand_Baggage;

  // const formatContent = (content: any, additionalText: any) => {
  //   const formattedContent = content?.replace(/__nls__/g, "<br />");
  //   return `${
  //     additionalText ? additionalText + " + " : ""
  //   } ${formattedContent}`;
  // };

  return (
    <div className="fligt-confirm">
      <div className="flight-indcator">
        <span>
          {/* <h5>Ahmedabad → LEH</h5> */}
          <h5>
            {route?.Flight?.Segments[0]?.Origin_City} →{" "}
            {
              route?.Flight?.Segments[route?.Flight?.Segments?.length - 1]
                ?.Destination_City
            }
          </h5>
        </span>
        <p>All departure/arrival times are in local time</p>
      </div>
      <div className="fare-rule">
        <span>
          {route?.Flight?.Segments?.length - 1 === 0
            ? "Non-Stop"
            : `${route?.Flight?.Segments?.length - 1} Stop`}
          {" - "}
          {/* {getDiffInHRAndMin(startTime, endTime)} */}
          {getTotalTravelDuration(route?.Flight?.Segments)}
        </span>
        {/* <span>1 stop.7h 10m</span> */}
        <a
          className="fw-bold"
          href="javascript:void(0)"
          data-bs-toggle="modal"
          data-bs-target={`#viewfarerule-${index}`}
          onClick={() => {
            if (
              cancellationCharges?.length <= 0 &&
              rescheduleCharges?.length <= 0
            ) {
              getFareRules(
                route?.Flight?.Fares && route?.Flight?.Fares[0]?.Fare_Id,
                route?.Flight?.Flight_Key
              );
            }
          }}
        >
          View fare rule
        </a>
        <div
          className="modal fade"
          id={`viewfarerule-${index}`}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="view-farerule"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered farerule-model">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title fs-5" id="edit-profile">
                  Fare Rule Information
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body pb-0 ">
                <div className="body-content mb-3" id="pills-tabContent">
                  <Loading loading={fareRulesLoading} />
                  {cancellationCharges?.length <= 0 &&
                  rescheduleCharges?.length <= 0 ? (
                    <>
                      {!fareRulesLoading && (
                        <>
                          {(fareRule && fareRule?.length === 0) ||
                          (fareRule?.length === 1 &&
                            !fareRule[0]?.FareRuleDesc) ? (
                            <h4 className="text-center">
                              {/* No Fare Rule Found. Please contact Customer Care!!! */}
                              Non - Refundable!!!
                            </h4>
                          ) : (
                            <div className="flight-cancel flight-detail flight-table">
                              <h5 className="m-0">
                                {route?.Flight?.Segments[0]?.Origin_City}{" "}
                                {" to "}
                                {
                                  route?.Flight?.Segments[
                                    route?.Flight?.Segments?.length - 1
                                  ]?.Destination_City
                                }
                              </h5>
                              <span className="mention-tag">
                                Mentioned fees are Per Pax Per Sector <br />{" "}
                                Apart from airline charges, GST + RAF +
                                applicable charges if any, will be charged.
                              </span>
                              <div style={{ maxHeight: 400, overflow: "auto" }}>
                                {fareRule?.map((e: any) => {
                                  return (
                                    <div
                                      style={{ padding: "0 10px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: e?.FareRuleDesc ?? "",
                                      }}
                                    />
                                  );
                                })}
                              </div>
                              <span className="d-block">
                                *From the Time of Departure
                              </span>
                              <span>*Service charge will be extra</span>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        maxHeight: "calc(100vh - 300px)",
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                      }}
                    >
                      {cancellationCharges?.length > 0 && (
                        <div className="cancel-wrapper">
                          <div className="cancel-table-container">
                            <table className="cancel-table">
                              <thead>
                                <tr>
                                  <th colSpan={5} className="cancel-th">
                                    <h4>Cancellation Charges</h4>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="cancel-th">#</th>
                                  <th className="cancel-th">Applicability</th>
                                  <th className="cancel-th">Passenger Type</th>
                                  <th className="cancel-th">Duration</th>
                                  <th className="cancel-th">Charge</th>
                                </tr>
                              </thead>
                              <tbody>
                                {cancellationCharges?.map(
                                  (cCharge: any, index: number) => {
                                    return (
                                      <tr className="cancel-row">
                                        <td className="cancel-td">
                                          {index + 1}
                                        </td>
                                        <td className="cancel-td">
                                          <span className="cancel-pill">
                                            Per{" "}
                                            {cCharge?.Applicablility === 0
                                              ? "Segment"
                                              : "Passenger"}
                                          </span>
                                        </td>
                                        <td className="cancel-td">
                                          {cCharge?.PassengerType === 0
                                            ? "Adult"
                                            : cCharge?.PassengerType === 1
                                            ? "Child"
                                            : "Infant"}
                                        </td>
                                        <td className="cancel-td">
                                          {cCharge?.DurationFrom}{" "}
                                          {cCharge?.DurationTypeFrom === 0
                                            ? "Hr(s) "
                                            : cCharge?.DurationTypeFrom === 1
                                            ? "days "
                                            : ""}{" "}
                                          – {cCharge?.DurationTo}{" "}
                                          {cCharge?.DurationTypeTo === 0
                                            ? "Hr(s)"
                                            : cCharge?.DurationTypeTo === 1
                                            ? "days"
                                            : ""}
                                        </td>
                                        <td className="cancel-td">
                                          {+cCharge?.Value === 0 ? (
                                            "Non Chargeable"
                                          ) : +cCharge?.Value === 100 &&
                                            cCharge?.ValueType === 1 ? (
                                            "Non Refundable"
                                          ) : (
                                            <>
                                              {cCharge?.ValueType === 0
                                                ? "₹ "
                                                : ""}
                                              {cCharge?.Value}
                                              {cCharge?.ValueType === 1
                                                ? "%"
                                                : ""}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                                <tr className="cancel-row">
                                  <td className="cancel-td" colSpan={5}>
                                    <strong className="d-block">
                                      *From the Time of Departure
                                    </strong>
                                    <strong>
                                      *Service charge will be extra
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                      {rescheduleCharges?.length > 0 && (
                        <div className="cancel-wrapper">
                          <div className="cancel-table-container">
                            <table className="cancel-table">
                              <thead>
                                <tr>
                                  <th colSpan={5} className="cancel-th">
                                    <h4>Reschedule Charges</h4>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="cancel-th">#</th>
                                  <th className="cancel-th">Applicability</th>
                                  <th className="cancel-th">Passenger Type</th>
                                  <th className="cancel-th">Duration</th>
                                  <th className="cancel-th">Charge</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rescheduleCharges?.map(
                                  (rCharge: any, index: number) => {
                                    return (
                                      <tr className="cancel-row">
                                        <td className="cancel-td">
                                          {index + 1}
                                        </td>
                                        <td className="cancel-td">
                                          <span className="cancel-pill">
                                            Per{" "}
                                            {rCharge?.Applicablility === 0
                                              ? "Segment"
                                              : "Passenger"}
                                          </span>
                                        </td>
                                        <td className="cancel-td">
                                          {rCharge?.PassengerType === 0
                                            ? "Adult"
                                            : rCharge?.PassengerType === 1
                                            ? "Child"
                                            : "Infant"}
                                        </td>
                                        <td className="cancel-td">
                                          {rCharge?.DurationFrom}{" "}
                                          {rCharge?.DurationTypeFrom === 0
                                            ? "Hr(s) "
                                            : rCharge?.DurationTypeFrom === 1
                                            ? "days "
                                            : ""}{" "}
                                          – {rCharge?.DurationTo}{" "}
                                          {rCharge?.DurationTypeTo === 0
                                            ? "Hr(s)"
                                            : rCharge?.DurationTypeTo === 1
                                            ? "days"
                                            : ""}
                                        </td>
                                        <td className="cancel-td">
                                          {+rCharge?.Value === 0 ? (
                                            "Non Chargeable"
                                          ) : +rCharge?.Value === 100 &&
                                            rCharge?.ValueType === 1 ? (
                                            "Non Refundable"
                                          ) : (
                                            <>
                                              {rCharge?.ValueType === 0
                                                ? "₹ "
                                                : ""}
                                              {rCharge?.Value}
                                              {rCharge?.ValueType === 1
                                                ? "%"
                                                : ""}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                                <tr className="cancel-row">
                                  <td className="cancel-td" colSpan={5}>
                                    <strong className="d-block">
                                      *From the Time of Departure
                                    </strong>
                                    <strong>
                                      *Service charge will be extra
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div
                className="modal-footer justify-content-end border-0 pt-0 pe-0"
                style={{
                  marginTop: 10,
                }}
              >
                <div className="travel-detail-btns mt-2">
                  <a
                    className="btn disable"
                    href="javascript:void(0)"
                    data-bs-dismiss="modal"
                    // ref={closeBtnRef}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="booking-timing">
        {route?.Flight?.Segments?.map((e: any, index: number) => {
          const flightNo = e?.Flight_Number;
          const flightCode = e?.Airline_Code;
          const departureTime = e?.Departure_DateTime;
          const arivalTime = e?.Arrival_DateTime;
          const duration = e?.Duration;
          const arivalCity = e?.Destination_City;
          const departureCity = e?.Origin_City;
          const arivalAirport = e?.Destination_Terminal;
          const departureAirport = e?.Origin_Terminal;
          const stops = e?.Stop_Over || 0;

          const previousArivalCity =
            route?.Flight?.Segments[index - 1]?.Destination_City;
          const isPlaneChange =
            flightNo !== route?.Flight?.Segments[index + 1]?.Flight_Number;

          let layoverTime = null;
          if (index > 0) {
            const previousFlightArrival = moment(
              route?.Flight?.Segments[index - 1]?.Arrival_DateTime,
              "MM/DD/YYYY HH:mm"
            );
            layoverTime = moment
              .duration(
                moment(
                  route?.Flight?.Segments[index]?.Departure_DateTime,
                  "MM/DD/YYYY HH:mm"
                ).diff(previousFlightArrival)
              )
              .asMinutes();
          }

          const flightClass =
            priceDetails.FareDetails[0]?.FareClasses[0]?.Class_Desc;

          return (
            <>
              {index > 0 && index < route?.Flight?.Segments?.length && (
                <div className="terminal-change">
                  <span>Change of Terminal</span>
                  <p>
                    {isPlaneChange ? "Require to change Plane, " : ""}
                    {layoverTime !== null && layoverTime > 0 && (
                      <>{formatMinToHRAndMin(layoverTime)}</>
                    )}{" "}
                    Layover in {previousArivalCity}
                  </p>
                </div>
              )}
              <div className="booking-flight-half">
                <div className="flight-choose">
                  <div className="fight-name">
                    <FlightImage
                      key={e.Airline_Code}
                      flightCode={e.Airline_Code}
                    />
                    <span className="max-w-none">
                      <h5>{e.Airline_Name}</h5>
                      <p>
                        {flightCode} - {flightNo}
                      </p>
                    </span>
                  </div>
                  <div className="flight-class">
                    <span>
                      <strong>{flightClass}</strong>
                    </span>
                  </div>
                </div>
                <div className="booking-timimg-main">
                  <div className="route-timing">
                    <div className="route-strating">
                      {moment(departureTime, "MM/DD/YYYY HH:mm").format(
                        "HH:mm"
                      )}
                      <p>
                        <strong>{departureCity}</strong>
                        {departureAirport
                          ? `, Terminal : ${departureAirport} `
                          : ""}
                      </p>
                    </div>
                    <div className="cunsume-time">
                      <p>
                        {stops === 0 ? "Non Stop" : `${stops} Stop`} |{" "}
                        <strong>{duration}</strong>
                      </p>
                      <div className="cunsume-pic">
                        <img src={PLANE} />
                      </div>
                      <p>
                        {moment(departureTime, "MM/DD/YYYY HH:mm").format(
                          "dddd, DD MMM’YY"
                        )}
                      </p>
                    </div>
                    <div className="route-strating route-arrival">
                      {moment(arivalTime, "MM/DD/YYYY HH:mm").format("HH:mm")}
                      <p>
                        <strong>{arivalCity}</strong>
                        {arivalAirport ? `, Terminal : ${arivalAirport} ` : ""}
                      </p>
                    </div>
                  </div>
                  <div className="mobile-timimg">
                    <div className="cunsume-time">
                      <p>
                        {stops === 0 ? "Non Stop" : `${stops} Stop`} |{" "}
                        <strong>{formatMinToHRAndMin(duration)}</strong>
                      </p>
                      <p>
                        {moment(departureTime, "MM/DD/YYYY HH:mm").format(
                          "dddd, DD MMM’YY"
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="fligt-parcel">
                    <div className="low-parcel">
                      <img src={BRIEFCASE} />
                      <span>
                        <strong>Cabin Baggage: </strong>
                        {adultCabbinBaggage || ""} / Adult
                      </span>
                    </div>
                    <div className="low-parcel">
                      <img src={BACKPACK} />
                      <span>
                        <strong>Check-In Baggage: </strong>
                        {adultCheckingBaggage} / Adult
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ReviewFlightRouteCard;
